<template>
	<div class="button">
		<button :class="classes"><slot /></button>
	</div>
</template>

<script>
import button from '@/mixins/button'

export default {
	name: 'Button',
	computed: {
		classes() {
			return {
				button__inner: true,
				'button__inner--active': this.pressed
			}
		}
	},
	mixins: [button()]
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.button {
	$height: 3.375rem;
	$z-height: 0.375rem;
	position: relative;
	width: 100%;
	height: $height + $z-height;

	&__inner {
		position: relative;
		color: white;
		text-transform: uppercase;
		font-size: 1rem;
		width: 100%;
		height: $height;
		appearance: none;
		border: 0;
		margin: 0;
		padding: 0;
		top: 0;
		background-color: $green-65;
		border-radius: 0.25rem;
		cursor: pointer;

		// 3D styling
		box-shadow: shadow-3d($z-height, $green-61), $box-shadow;
		transition: box-shadow $anim-button, top $anim-button;
		&--active {
			top: $z-height;
			box-shadow: 0 0 0 0 $green-61;
		}
	}
}
</style>
